import { useCallback } from 'react';
import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';
import { ConfirmEnrollmentProps } from '../widgets/care-credit-enrollment-multi-step/enrollment-multi-step.types';

export type UseCareCreditEnrollmentConfirmApplicationProps = {
  merchantNumber: string | undefined;
  locationId: string | undefined;
};
export const useCareCreditEnrollmentConfirmApplication = ({
  merchantNumber,
  locationId,
}: UseCareCreditEnrollmentConfirmApplicationProps) => {
  const { mutateAsync, isLoading, isSuccess, error } =
    CareCreditIntegrationV1.Mutations.useAcceptPrequalificationOfferMutation();

  const confirmApplication = useCallback(
    async ({ enrollmentResult }: ConfirmEnrollmentProps) => {
      if (!merchantNumber) {
        throw new Error('Merchant number is required to confirm CareCredit enrollment application');
      }

      return await mutateAsync({
        applicationId: enrollmentResult?.applicationId ?? '',
        locationId,
      });
    },
    [locationId, mutateAsync, merchantNumber]
  );

  return {
    confirmApplication,
    isSubmitting: isLoading,
    isSuccess,
    error,
  };
};
